module.exports = __webpack_public_path__ + "static/media/productivityActive.e840a566.svg";